import { palette } from "@bonusx-global/bx-design-system";
import { Global } from "@emotion/react";
import CssBaseline from "@mui/material/CssBaseline";
import type { PropsWithChildren } from "react";
import { Modal } from "../../legacy/components/poppers/Modal";
import { BonusXThemeProvider } from "../../legacy/theme/BonusXThemeProvider";
import type { IBaseLayoutV2Props } from "./BaseLayoutV2";
import BodyContainer from "./BaseLayoutv2/BodyContainer";
import HeaderContainer from "./BaseLayoutv2/HeaderContainer";

const globalStyles = ` 
  body {
    background-color: ${palette?.background?.default} !important;
  }
`;

interface IBaseLayoutV2AdjustableProps extends IBaseLayoutV2Props {
  readonly bodyWidth?: string;
}

export const DEFAULT_BODY_WIDTH = "100%";

export function BaseLayoutV2Adjustable({
  children,
  header,
  bodyWidth = DEFAULT_BODY_WIDTH,
}: PropsWithChildren<IBaseLayoutV2AdjustableProps>): JSX.Element {
  return (
    <BonusXThemeProvider>
      <CssBaseline />
      <Global styles={globalStyles} />
      <Modal />
      <HeaderContainer>{header}</HeaderContainer>
      <BodyContainer width={bodyWidth}>{children}</BodyContainer>
    </BonusXThemeProvider>
  );
}
